var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMydatagrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1756865185993,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7768,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0C296.192 0 64 65.056 64 208v608C64 958.88 296.192 1024 512 1024c215.776 0 448-65.12 448-208v-608C960 65.056 727.744 0 512 0z m384 816c0 79.488-171.936 144-384 144-212.096 0-384-64.512-384-144v-119.552C194.112 764.576 353.6 800 512 800s317.888-35.424 384-103.552V816z m0-192h-0.128c0 0.32 0.128 0.672 0.128 0.992C896 704 724.064 768 512 768S128 704 128 624.992c0-0.32 0.128-0.672 0.128-0.992H128v-119.552C194.112 572.576 353.6 608 512 608s317.888-35.424 384-103.552V624z m0-192h-0.128c0 0.32 0.128 0.672 0.128 0.992C896 512 724.064 576 512 576S128 512 128 432.992c0-0.32 0.128-0.672 0.128-0.992H128v-109.952C211.872 385.952 365.6 416 512 416s300.128-30.048 384-93.952V432zM512 352C299.904 352 128 287.488 128 208 128 128.448 299.904 64 512 64c212.064 0 384 64.448 384 144 0 79.488-171.936 144-384 144z",
    fill: "#6b7280",
    "p-id": 7769
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M800 832m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z",
    fill: "#6b7280",
    "p-id": 7770
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M800 640m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z",
    fill: "#6b7280",
    "p-id": 7771
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M800 448m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z",
    fill: "#6b7280",
    "p-id": 7772
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMydatagrey);
export default __webpack_public_path__ + "static/media/mydatagrey.3fb4c5ad.svg";
export { ForwardRef as ReactComponent };